export default "__VITE_ASSET__ClpdLMi1__"